import { AppPalette } from '../../colors'

export const MuiOutlinedInput = {
  styleOverrides: {
    root: {
      height: '42px',
      border: 'none',
      boxSizing: 'border-box',
      color: 'white',
      // ['&:not(.Mui-error):not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline']: {
      //   borderColor: 'red'
      // },
      // '&:hover fieldset': {
      //   borderColor: '#3E68A8',
      //   borderWidth: '0.15rem'
      // },
      // '&.Mui-focused fieldset': {
      //   borderColor: '#3E68A8'
      // }
      '& fieldset': {
        borderColor: AppPalette.BORDER.dark,
      },
      '.MuiInputBase-input ': {
        color: AppPalette.GREY.secondary,
      },
    },
    input: {
      zIndex: 1,
      padding: '12px 16px',
      '&::placeholder': {
        color: '#999999',
      },
    },
  },
}
